module.exports = __webpack_public_path__ + "static/media/Focus V024.e855b83a.vtt";